import * as Yup from 'yup'

const catalogServiceValidator = Yup.object ({
  service: Yup.object ()
    .nullable ()
    .required ('Selecione um serviço'),
    
  description: Yup.string ()
    .required ('Digite a descrição do serviço')
    .max (512, 'A descrição deve conter até 512 caracteres'),

  images: Yup.array ()
    .max (5, 'O catálogo pode conter até 5 fotos')
    .of (Yup.object ())
})

export default catalogServiceValidator
